import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import { defaultHouseBillingStatusSlice } from '@/redux/modules/billingManagement/houseBillingStatus/houseBillingStatus.types';
import {
    fetchHouseBillingStatus,
    saveHouseBillingAccountStatus,
} from '@/redux/modules/billingManagement/houseBillingStatus/houseBillingStatus.actions';
import { saveHouseBillingCurrency } from '@/redux/modules/billingManagement/houseBillingCurrency/houseBillingCurrency.actions';
import difference from 'lodash/difference';

const houseBillingStatusSlice = createSlice({
    extraReducers: (builder) => {
        builder.addCase(fetchHouseBillingStatus.pending, (slice, { meta }) => {
            slice.loading.push(meta.arg.houseId);
        });
        builder.addCase(fetchHouseBillingStatus.fulfilled, (slice, { payload }) => {
            slice.byId[payload.houseId] = payload;
            slice.loading = difference(slice.loading, [payload.houseId]);
        });
        builder.addCase(fetchHouseBillingStatus.rejected, (slice, { meta }) => {
            slice.loading = difference(slice.loading, [meta.arg.houseId]);
        });

        builder.addMatcher(
            isAnyOf(saveHouseBillingCurrency.pending, saveHouseBillingAccountStatus.pending),
            (slice) => {
                slice.isSaving = true;
            }
        );
        builder.addMatcher(
            isAnyOf(
                saveHouseBillingCurrency.fulfilled,
                saveHouseBillingAccountStatus.fulfilled,

                saveHouseBillingCurrency.rejected,
                saveHouseBillingAccountStatus.rejected
            ),
            (slice) => {
                slice.isSaving = false;
            }
        );
    },
    initialState: defaultHouseBillingStatusSlice,
    name: 'houseBillingStatus',
    reducers: {},
});

export const { reducer: houseBillingStatusReducer } = houseBillingStatusSlice;
